'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { ArrowIcon } from '@insta-club/components';
import { useCustomForm } from '@insta-club/hooks';
import { Button, Form, Input } from '@insta-club/ui';
import { SignInFormValues, SignInSchema } from '@insta-club/validator';
import { useRouter, useSearchParams } from 'next/navigation';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';

function ForgetPasswordForm() {
    const searchParams = useSearchParams();
    const username = searchParams.get('username');

    const router = useRouter();
    const form = useCustomForm(SignInSchema, { username: username ?? '' });

    const onSubmit: SubmitHandler<SignInFormValues> = async (data) => {
        try {
            const { username } = data;
            const res: { exist: boolean; ttl: number } = await fetcher(ApiKeys.SIGN_IN, 'web', 'POST', {
                body: {
                    username
                }
            });

            if (res?.exist) {
                router.push(`/auth/otp?exist=${res?.exist}&username=${username}&method=forget-password`);
            } else {
                form.setError('username', {
                    message: 'شماره موبایل یا ایمیل در اینستا کلاب حساب کاربری ندارد.'
                });
            }

            await fetcher(ApiKeys.SEND_VERIFICATION_CODE, 'web', 'POST', {
                body: {
                    username
                }
            });
        } catch (err: unknown) {
            toast.removeAll();
            if (err instanceof Error) {
                toast.error('خطای ناشناخته رخ داده است');
            } else {
                toast.removeAll();
                form.setError('username', {
                    message: (err as { error: { message: string } })?.error.message || 'خطا در اعتبار سنجی کد تایید'
                });
            }
        }
    };

    return (
        <>
            <Form form={form} onSubmit={onSubmit}>
                <div className='flex flex-col space-y-6'>
                    <Input name='username' inputType='text' label='شماره همراه یا ایمیل' />
                    <Button
                        loading={form.formState.isSubmitting}
                        type='submit'
                        size='lg'
                        fullWidth
                        icon={<ArrowIcon className='rotate-180 text-white' />}
                        iconPosition='end'
                    >
                        <span className='text-base font-semibold'>مرحله بعد</span>
                    </Button>
                </div>
            </Form>
        </>
    );
}

export default ForgetPasswordForm;

